import { Injectable } from '@angular/core';
import { UserActivation } from 'src/app/models/UserActivation';
import { Observable } from 'rxjs';
//var Configuration = require('src/assets/app-config.json');
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { IUserDetails } from 'src/app/models/IUsersDetails';
import { configuration } from 'src/environments/environment';
import { Defaults } from 'src/app/Utilities/defaults';
import { IExostars } from 'src/app/models/IExostars';
import { ExoStar } from 'src/app/models/ExoStar';
@Injectable({
  providedIn: 'root'
})

export class ActiveserviceService {

  constructor(private http: HttpClient) { }
  updateUserStatus(activeUsers:IUserDetails): Observable<string> {
    const posteddata={
      inputdata:JSON.stringify(activeUsers)
    }  
    return this.http.put<string>(`${configuration.apiUrl + 'Admin/LoginAttempts'}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }
  
  getAllUsers(): Observable<IUserDetails[]> {
    return this.http.get<IUserDetails[]>(
      `${configuration.apiUrl + 'Activation/allRoleUsers'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&facilityid=${sessionStorage.getItem("FacilityId")}`);
  }

  getUnlockUsers(): Observable<IUserDetails[]> {
    return this.http.get<IUserDetails[]>(
      `${configuration.apiUrl + 'Activation/UnLockUsers'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&facilityid=${sessionStorage.getItem("FacilityId")}`);
  }
  
  getProviders(): Observable<IExostars[]> {
    return this.http.get<IExostars[]>(`${configuration.clinicapiUrl + 'ExoStar/GetExostarUser'}`);
  }

  getLicenseKeys(): Observable<ExoStar[]> {
    return this.http.get<ExoStar[]>(`${configuration.clinicapiUrl + 'ExoStar/GetExostarLicensekeys'}`);
  }
}
